module.exports = __webpack_public_path__ + "static/img/qrcode.bb8abebd.jpg";